import React, { useEffect, useState } from 'react';
import { topTrendingBlogs } from '../utils/blogsHelper';
import { useNavigate, Link } from 'react-router-dom';

function Home() {
  const [blogs, setBlogs] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const trendingBlogs = await topTrendingBlogs();
        setBlogs(trendingBlogs);
      } catch (err) {
        setError(err.message);
      }
    };
    loadBlogs();
  }, []);

  if (error) return <div>Error: {error}</div>;

  return (
    <div className="page-wrapper">
      <div className="home-container" style={{ textAlign: 'center' }}>
        <h2> Ubaid R Butt </h2>
        <div style={{ 
          width: '300px',
          height: '300px',
          margin: '20px auto 0',
          overflow: 'hidden',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}>
          <img 
            src="https://raw.githubusercontent.com/ubaidbutt/my-blogs/main/images/main-picture.jpeg" 
            alt="Main Picture" 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
          />
        </div>
        <p style={{ 
          margin: '1rem 0', 
          maxWidth: '800px', 
          marginLeft: 'auto', 
          marginRight: 'auto', 
          textAlign: 'center'
        }}>
          Welcome to my blog which is a small corner on the Internet for me to share my thoughts about everything in life.
        </p>
        <div style={{ textAlign: 'center' }}>
          <button 
            onClick={() => navigate('/about')} 
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1a73e8',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#155ab6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a73e8'}
          >
            More about me
          </button>
        </div>
        <p className="paragraph-font"> <strong> The following articles provide some insights into my life and my perspective on a few topics. </strong> </p>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 16px' }}>
          <div className="articles-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '16px' }}>
            {blogs.slice(0, 6).map((blog, index) => (
              <div
                key={index}
                className="article-card"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  transition: 'transform 0.2s',
                  height: '150px',
                }}
                onMouseEnter={() => (event.currentTarget.style.transform = 'scale(1.02)')}
                onMouseLeave={() => (event.currentTarget.style.transform = 'scale(1)')}
                onClick={() => navigate(`/blogs/${encodeURIComponent(blog.url_title)}`, {
                  state: { fileUrl: blog.file_url, title: blog.name }
                })}
              >
                <h2 className="article-title article-title-font" style={{ margin: 0, color: '#1a73e8' }}>{blog.name}</h2>
                <div className="tags" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '8px' }}>
                  {blog.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ 
          marginTop: '20px',
          marginBottom: '40px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <button 
            onClick={() => navigate('/blogs')} 
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1a73e8',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#155ab6'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1a73e8'}
          >
            Read More Blogs
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;